export default {"src":"/_next/static/media/volume-up.0d6c475e.svg","height":9,"width":12,"blurWidth":0,"blurHeight":0};